import { FC } from "react"
import classes from "./Loading.module.css"
import { SpinnerSVG } from "./SpinnerSVG"

const Loading: FC = () => (
  <div className={classes.container}>
    <SpinnerSVG />
  </div>
)

export default Loading
